<template>
  <b-form-group
    class="form-floating"
    :description="description"
    :invalid-feedback="invalidFeedback"
  >

    <slot></slot>
    
    <label :for="labelFor" :class="labelClass" class="form-label">{{ label }}</label>

  </b-form-group>
</template>
<script>
  export default {
    props: {
      label: String,
      labelFor: {type: String, required: true},
      labelClass: [String, Object],
      invalidFeedback: String,
      description: String,
    },
  }
</script>